import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class VanityHandle extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_handle';
    this.partName = 'Handle';
    this.translateId = "visualizer.bathroom.vanity.vanity_handle";
    this.dbName = "Vanity Handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityHandle())
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.getCounterTopSize()
    })
    return conditions
  }

  getAvailableFeatures() {
    return this.features && this.features.filter(f => f.matchesMetaForCondition('VanitySize', this.getParent().counterTopSize())) || [];
  }

  setLayers(layout) {

    const vanityPedestal = this.getParent().vanityCabinet;
    if (vanityPedestal && vanityPedestal.activeFeature) {
      const handleMeta =  vanityPedestal.activeFeature.metaData["VanityHandle"];
      const hardCodedWizardConditions = vanityPedestal.activeFeature.partName.includes("WizardPlaceholder") &&
        (
          vanityPedestal.activeFeature.partName.includes("WizardPlaceholder52 in36 S")
          || (handleMeta && handleMeta.includes("true"))  // WizardPlaceholder QC Liberty
        );
      if (handleMeta && handleMeta.includes("None") || hardCodedWizardConditions) {
        super.hideLayers();
        return;
      }
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      const zIndex = zIndexes.Vanity.Handle;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
